const Endpoints = {
    login: `${process.env.RETUL_API}token/obtain/`,
    refresh: `${process.env.RETUL_API}token/refresh/`,
    sessions: `${process.env.RETUL_API}session/list/`,
    bodyData: `${process.env.RETUL_API}session/latest/`,
    shoeMatches: `${process.env.RETUL_API}session/latest-shoes/`,
    bikeMatches: `${process.env.RETUL_API}session/latest-bikes/`,
    saddleMatches: `${process.env.RETUL_API}session/latest-saddles/`,
    user: `${process.env.RETUL_API}accounts/user/`,
    passwordReset: `${process.env.RETUL_API}v2/reset-password/`, // CDJ: maybe resetPassword instead? check codebase
    confirmPasswordReset: `${process.env.RETUL_API}v2/confirm-password/`,
    register: `${process.env.RETUL_API}v2/register-user/`,
    verify: `${process.env.RETUL_API}v2/verify-email/`,
};

export default Endpoints;



// WEBPACK FOOTER //
// ./src/client/helpers/enums/endpoints.js